
import { createClient } from 'contentful';

// Contentful space credentials
const CONTENTFUL_SPACE_ID = 'v27mnfvqezea';
const CONTENTFUL_ACCESS_TOKEN = 'yPT2AwkIx-x2PudjtX0PMCoN4xkJ-aRZNIxOaeC9kjo';

// Initialize the Contentful client
export const contentfulClient = createClient({
  space: CONTENTFUL_SPACE_ID,
  accessToken: CONTENTFUL_ACCESS_TOKEN,
});

export const getContentfulCredentials = () => {
  return {
    spaceId: CONTENTFUL_SPACE_ID,
    accessToken: CONTENTFUL_ACCESS_TOKEN,
  };
};
